import { render, staticRenderFns } from "./veStuStipendTypeEdit.vue?vue&type=template&id=215cfb5b&scoped=true"
import script from "./veStuStipendTypeEdit.vue?vue&type=script&lang=js"
export * from "./veStuStipendTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215cfb5b",
  null
  
)

export default component.exports